import { useMemo } from 'react';
import { getButtonState } from 'src/components/design-system/Button';
import { Trigger } from 'src/services/useInvoiceDetailsApi';
import { PoTrigger } from 'src/services/usePoDetailsApi';

const usePoButtonState = (triggerPreCheck: Trigger[], trigger: typeof PoTrigger[number]) => {
  const [messages, buttonState] = useMemo(
    () => getButtonState(triggerPreCheck, trigger, PoTrigger as unknown as string[]),
    [trigger, triggerPreCheck]
  );
  return [messages, buttonState] as const;
};
export default usePoButtonState;
